import React from 'react';
import { useLocation } from 'wouter'
import { 
    Button,
    HStack, 
    IconButton,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    useBreakpointValue,
    Box
} from '@chakra-ui/react'
import { HamburgerIcon } from '@chakra-ui/icons'
import { SiInstagram, SiGithub } from "react-icons/si";
import { GiEarthAfricaEurope } from "react-icons/gi";
import { FaCalculator } from "react-icons/fa";
import { FaMicrochip } from "react-icons/fa";
import { CgFileDocument } from "react-icons/cg";
import { FaUser } from "react-icons/fa";

export function Header(){
    const [location, setLocation] = useLocation();
    
    // Determina si mostrar el menú completo o contraído
    const isDesktop = useBreakpointValue({ base: false, md: true });
    
    const irAbout = () => {
        setLocation("/");
    };
    const irInstagram = () => {
        setLocation("/instagram");
    };
    const irConstruyendo = () => {
        setLocation("/construyendo");
    };
    const irSensores = () => {
        setLocation("/sensores");
    };
    const irCv = () => {
        setLocation("/cv");
    };

    // Menú para escritorio
    const DesktopMenu = () => (
        <HStack spacing={2}>
            <Button 
                borderRadius={'full'}
                onClick={irAbout}
                variant='ghost'
                _hover={{ bg: "transparent" }}
                _active={{ bg: "transparent" }}
            >
                Sobre mi
            </Button>
    
            <Button 
                borderRadius={'full'}
                onClick={irCv}
                variant='ghost'
                _hover={{ bg: "transparent" }}
                _active={{ bg: "transparent" }}
            >
                CV
            </Button>

            <Button 
                borderRadius={'full'}
                onClick={irConstruyendo}
                variant='ghost'
                _hover={{ bg: "transparent" }}
                _active={{ bg: "transparent" }}
            >
                
                Construyendo 
                
            </Button>
            
            <Button 
                borderRadius={'full'}
                onClick={irInstagram}
                color={'white'}
                variant='ghost'
                _hover={{ bg: "transparent" }}
                _active={{ bg: "transparent" }}
            >
                <SiInstagram />
            </Button>

            <Button
                borderRadius={'full'}
                onClick={() => setLocation("/mapa")}
                color={'orange'}
                variant='ghost'
                _hover={{ bg: "transparent" }}
                _active={{ bg: "transparent" }}
            >
                <GiEarthAfricaEurope />
            </Button>

            {/* <Button
                borderRadius={'full'}
                onClick={() => setLocation("/calculadora")}
                color={'gray'}
                variant='ghost'
                _hover={{ bg: "transparent" }}
                _active={{ bg: "transparent" }}
            >
                <FaCalculator />
            </Button> */}

            <Button
                borderRadius={'full'}
                onClick={() => window.location.href = "https://github.com/ladopixel"}
                color={'cyan'}
                variant='ghost'
                _hover={{ bg: "transparent" }}
                _active={{ bg: "transparent" }}
            >
                <SiGithub />
            </Button>
        </HStack>
    );

    // Menú para móviles (hamburguesa)
    const MobileMenu = () => (
        <Menu>
            <MenuButton
                as={IconButton}
                aria-label='Options'
                icon={<HamburgerIcon />}
                variant='ghost'
                borderRadius={'full'}
            />
            <MenuList>
                <MenuItem onClick={irAbout}>
                    <FaUser style={{ marginRight: '8px' }} />
                    Sobre mi
                </MenuItem>
                <MenuItem onClick={irCv}>
                    <CgFileDocument style={{ marginRight: '8px' }} />
                    CV
                </MenuItem>
                <MenuItem onClick={irConstruyendo}>
                    <FaMicrochip style={{ marginRight: '8px' }}/> 
                    Construyendo
                </MenuItem>
                <MenuItem onClick={irInstagram}>
                    <SiInstagram style={{ marginRight: '8px' }} />
                    Instagram
                </MenuItem>
                <MenuItem onClick={() => setLocation("/mapa")}>
                    <GiEarthAfricaEurope style={{ marginRight: '8px' }} />
                    Mapa
                </MenuItem>
                {/* <MenuItem onClick={() => setLocation("/calculadora")}>
                    <FaCalculator style={{ marginRight: '8px' }} />
                    Calculadora
                </MenuItem> */}
                <MenuItem onClick={() => window.location.href = "https://github.com/ladopixel"}>
                    <SiGithub style={{ marginRight: '8px' }} />
                    GitHub
                </MenuItem>
            </MenuList>
        </Menu>
    );

    return (
        <Box w="100%" px={5} py={5}>
            <HStack w="100%" justifyContent="flex-end">
                {isDesktop ? <DesktopMenu /> : <MobileMenu />}
            </HStack>
        </Box>
    );
}